import { CuentaRevisor } from './../../../models/cuenta_revisor.model';
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';


declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-cuenta-revisor',
  templateUrl: './cuenta-revisor.component.html',
  styleUrls: ['./cuenta-revisor.component.css'],
  providers: [FormService]
})

export class CuentaRevisorComponent {
  public rows = [];
  public actualRow;
  public cuentaRevisor: CuentaRevisor;
  public form;


  constructor(public _formService: FormService, private fb: FormBuilder) {
    this.form = new FormGroup({
      informe: new FormControl(''),
      numero: new FormControl(''),
      fecha: new FormControl(''),
      registro: new FormControl(''),
      categoria: new FormControl(''),

    })

    if (!JSON.parse(localStorage.getItem("cuentaRevisor"))) {
      localStorage.setItem("cuentaRevisor", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("cuentaRevisor"));
      this.form.controls['informe'].setValue(this.rows[0] ? this.rows[0].informe : '');
      this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '');
      this.form.controls['fecha'].setValue(new Date(this.rows[0] ? this.rows[0].fecha : ''));
      this.form.controls['registro'].setValue(this.rows[0] ? this.rows[0].registro : '');
      this.form.controls['categoria'].setValue(this.rows[0] ? this.rows[0].categoria : '');
    }
    this.cuentaRevisor = {
      informe: '',
      numero: '',
      fecha: '',
      registro: '',
      categoria: '',

    }
  }

  add_revisor() {
    //var checkDeclaracion = event.value;
    localStorage.setItem("cuentaRevisor", JSON.stringify([]))
    this.actualRow = localStorage.getItem("cuentaRevisor");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      informe: this.form.value.informe,
      numero: this.form.value.numero,
      fecha: this.form.value.fecha ? moment(this.form.value.fecha).format('DD/MM/YYYY') : "",
      registro: this.form.value.registro,
      categoria: this.form.value.categoria,

    })

    localStorage.setItem("cuentaRevisor", JSON.stringify(this.rows));
  }

  delete_revisor(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("cuentaRevisor", JSON.stringify(this.rows));
      }
    }
  }
}
